export default function transformContactsToBorrower(contacts) {
  return contacts.map((c) => ({
    borrower: c.fullName || '',
    llc: c.llc || '',
    state: c.state.value || (typeof c.state === 'string' ? c.state : ''),
  }))
}

export const emptyRow = {
  address: "",
  country_code: "",
  current_market_value: "",
  group: "",
  id: "",
  key: "",
  lender_name: "",
  meta: "",
  mortgage_payment: "",
  municipality: "",
  ownership_percent: "",
  postal_code: "",
  premise: "",
  purchase_date: "",
  purchase_price: "",
  rehab_budget: "",
  rent_amount: "",
  sale_date: "",
  sale_price: "",
  state_code: "",
  state_name: "",
  title_name: "",
  total_mortgage_amount: "",
  type: "",
  _new: ""
};

export const REQUIRED_FIELDS_CONFIG = {
  fix_and_flips: ['address', 'titleName', 'ownershipPercent', 'purchaseDate', 'purchasePrice', 'rehabBudget', 'salePrice', 'saleDate'],
  investment_properties_owned: ['address', 'titleName', 'ownershipPercent', 'purchaseDate', 'currentMarketValue', 'lenderName', 'totalMortgageAmount', 'mortgagePayment', 'rentAmount', 'marketRent'],
  primary_residence: ['address', 'titleName', 'ownershipPercent', 'purchaseDate', 'lenderName']
};

export const GROUP_ENUM = {
  bridge: 'fix_and_flips',
  rental: 'investment_properties_owned',
  primary: 'primary_residence'
};

export const isRowAtLeastOneCellComplete = (row, fields) => {
  return fields.some((field) => {
    const value = row[field];
    return value !== undefined && value !== null && value !== '';
  });
};

export const isRowIncomplete = (row, fields) => {
  return fields.some((field) => {
    const value = row[field];
    return value === undefined || value === null || value === '';
  });
};

export function isRowFilled(row, requiredFields) {
  return requiredFields.every((field) => {
    const value = row[field];
    return value !== undefined && value !== null && value !== '';
  });
};

export const GROUP_COLUMN_CONFIG = {
  bridge: 10,
  rental: 9,
  primary: 8
};

export const snakeToCamel = (str) => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const requiredFields = (group) => {
  const fieldMap = {
    fix_and_flips: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'purchasePrice',
      'rehabBudget',
      'salePrice',
      'saleDate'
    ],
    investment_properties_owned: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'currentMarketValue',
      'lenderName',
      'totalMortgageAmount',
      'mortgagePayment',
      'rentAmount',
      'marketRent'
    ],
    primary_residence: [
      'address',
      'titleName',
      'ownershipPercent',
    ]
  };

  return fieldMap[group] || [];
};
